// // routes
// import { paths } from 'src/routes/paths';
// // utils
// import axios from 'src/utils/axios';
// // ----------------------------------------------------------------------
// function jwtDecode(token: string) {
//   const base64Url = token.split('.')[1];
//   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//   const jsonPayload = decodeURIComponent(
//     window
//       .atob(base64)
//       .split('')
//       .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
//       .join('')
//   );
//   return JSON.parse(jsonPayload);
// }
// // ----------------------------------------------------------------------
// export const isValidToken = (accessToken: string) => {
//   if (!accessToken) {
//     return false;
//   }
//   const decoded = jwtDecode(accessToken);
//   const currentTime = Date.now() / 1000;
//   return decoded.exp > currentTime;
// };
// // ----------------------------------------------------------------------
// export const tokenExpired = (exp: number) => {
//   // eslint-disable-next-line prefer-const
//   let expiredTimer;
//   const currentTime = Date.now();
//   // Test token expires after 10s
//   // const timeLeft = currentTime + 10000 - currentTime; // ~10s
//   const timeLeft = exp * 1000 - currentTime;
//   clearTimeout(expiredTimer);
//   expiredTimer = setTimeout(() => {
//     alert('Token expired');
//     sessionStorage.removeItem('accessToken');
//     window.location.href = paths.auth.jwt.login;
//   }, timeLeft);
// };
// // ----------------------------------------------------------------------
// // export const setSession = (accessToken: string | null) => {
// //   if (accessToken) {
// //     sessionStorage.setItem('accessToken', accessToken);
// //     axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
// //     // This function below will handle when token is expired
// //     const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
// //     tokenExpired(exp);
// //   } else {
// //     sessionStorage.removeItem('accessToken');
// //     delete axios.defaults.headers.common.Authorization;
// //   }
// // };
// export const setSession = (accessToken: string | null) => {
//   if (accessToken) {
//     sessionStorage.setItem('accessToken', accessToken);
//     axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
//     // Check if the token is a JWT (must have 3 parts separated by '.')
//     const isJwt = accessToken.split('.').length === 3;
//     if (isJwt) {
//       try {
//         const { exp } = jwtDecode(accessToken);
//         tokenExpired(exp);
//       } catch (error) {
//         console.warn('JWT decoding failed:', error);
//       }
//     } else {
//       console.info('Token is not JWT, skipping expiration handling.');
//     }
//   } else {
//     sessionStorage.removeItem('accessToken');
//     delete axios.defaults.headers.common.Authorization;
//   }
// };



// routes
import { paths } from 'src/routes/paths';
// utils
import axios from 'src/utils/axios';

/* ------------------------------------------------------------------ */
/* JWT Decode Helper */
/* ------------------------------------------------------------------ */
function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );
  return JSON.parse(jsonPayload);
}

/* ------------------------------------------------------------------ */
/* Token Validation */
/* ------------------------------------------------------------------ */
export const isValidToken = (accessToken: string) => {
  if (!accessToken) return false;

  try {
    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    console.warn('Invalid JWT token:', error);
    return false;
  }
};

/* ------------------------------------------------------------------ */
/* Token Expiration Handler (DISABLED) */
/* ------------------------------------------------------------------ */
/**
 * ❌ DO NOT use timers for token expiration
 * ✅ Let Axios interceptor handle refresh / logout
 */
export const tokenExpired = (_exp: number) => {
  // intentionally empty
};

/* ------------------------------------------------------------------ */
/* Set Session */
/* ------------------------------------------------------------------ */
export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    // Save token
    sessionStorage.setItem('accessToken', accessToken);

    // Attach to axios
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // Optional JWT validation (NO timer)
    const isJwt = accessToken.split('.').length === 3;
    if (isJwt) {
      try {
        jwtDecode(accessToken); // just validate structure
      } catch (error) {
        console.warn('JWT decode failed:', error);
      }
    }
  } else {
    // Clear session
    sessionStorage.removeItem('accessToken');
    localStorage.removeItem('refresh_token');
    delete axios.defaults.headers.common.Authorization;

    // Redirect to login
    window.location.href = paths.auth.jwt.login;
  }
};
